import { SecondaryButton } from 'components/Button/SecondaryButton';
import { useMainDispatch } from 'modules/main/store';
import { showModal } from 'modules/main/store/ducks/modal';

type Props = {
  hasSocialShare: boolean;
  canSubscribe: boolean;
  isSubscribed: boolean;
  shareUrl: Record<UserLocale, string>;
  subscribe: () => Promise<void>;
};

export function CmsButtonBar({
  canSubscribe,
  hasSocialShare,
  shareUrl,
  subscribe,
  isSubscribed,
}: Props) {
  const dispatch = useMainDispatch();

  function handleShare() {
    dispatch(
      showModal('SHARE_LISTING', {
        listing: { type: 'URL' },
        listingType: 'URL',
        messageOverride: getText('Check out this article'),
        shareUrl,
      }),
    );
  }

  return (
    <>
      {canSubscribe ? (
        <SecondaryButton
          onClick={subscribe}
          iconName="bell"
          data-qa-id="button-bar-subscribe-to-subsite"
          disabled={isSubscribed}
          size="medium"
        >
          {isSubscribed ? getText('Subscribed') : getText('Subscribe')}
        </SecondaryButton>
      ) : null}
      {hasSocialShare ? (
        <SecondaryButton
          onClick={() => handleShare()}
          iconName="share"
          data-qa-id="button-bar-social-share-button"
          size="medium"
        >
          {getText('Share')}
        </SecondaryButton>
      ) : null}
    </>
  );
}
